export default {"src":"/_next/static/media/relend-light.54b82823.svg","height":79,"width":75,"blurWidth":0,"blurHeight":0};